import { IconBase } from './IconBase'

type IconChevronUpProps = React.ComponentProps<'svg'>

export const IconChevronUp = (props: IconChevronUpProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.283 6.204a1.33 1.33 0 0 0-.383.268L1.472 15.9a1.333 1.333 0 1 0 1.886 1.886L12 9.144l8.527 8.528a1.333 1.333 0 1 0 1.886-1.886l-9.428-9.428a1.334 1.334 0 0 0-1.702-.154Z"
      />
    </IconBase>
  )
}
